import React from 'react';

import { take, takeRight } from 'lodash';
import { Button } from 'react-bootstrap';
import { translate } from 'react-i18next';
class PaginationTable extends React.Component {
  state = {
    // paging
    continued: false,
    totalCount: 0,
    page: 1,
    contentShow: [],
    _totalPage: 1,
  };

  componentDidUpdate(preProps) {
    const { source } = this.props;
    if (source !== preProps.source) {
      this.setState({ totalCount: source ? source.length : 0 });
      this.handleQueryPage(1);
    }
  }

  handleQueryPage = (page) => {
    const { source, pageSize } = this.props;
    if (!source) return;
    const _pageSize = pageSize || 15;
    const _totalPage =
      source.length > 0 ? Math.ceil(source.length / _pageSize) : 1;

    const _takeContent = take(source, _pageSize * page);
    const _contentShow = takeRight(
      _takeContent,
      _takeContent.length - _pageSize * (page - 1)
    );
    // console.log(_contentShow);
    this.setState({
      contentShow: _contentShow,
      page,
      continued: page < _totalPage,
      _totalPage,
    });
  };

  _handleNextPage = (step) => {
    const { page } = this.state;
    this.handleQueryPage(page + step);
  };

  render() {
    const {
      source,
      columns,
      defaultAccount,
      onRowClicked,
      tblClassName,
      divClassName,
      pageSize,
      t,
    } = this.props;
    const { page, continued, _totalPage, contentShow } = this.state;

    const _pageSize = pageSize || 15;

    return (
      <div className={'d-flex flex-column ' + (divClassName || 'm-2')}>
        <table className={'table table-bordered ' + (tblClassName || '')}>
          <thead>
            <tr>
              {columns.map((column, index) => {
                let classText = column.sortable ? 'sortable ' : '',
                  width = column.width ? column.width : '',
                  align = column.align ? column.align : '',
                  // sortOrder = "",
                  columnStyle = {};
                // if (column.sortable && this.state.sort.column == column.key) {
                //   sortOrder = this.state.sort.order;
                //   classText += (sortOrder) ? " " + sortOrder : "";
                //   columnStyle = (sortOrder == "asc") ? style.sort_asc : style.sort_desc;
                // }

                classText += ' text-' + align;
                if (column.TrOnlyClassName)
                  classText += ' ' + column.TrOnlyClassName;
                return (
                  <th
                    key={column.key ? column.key : column.text}
                    className={classText}
                    width={width}
                    style={columnStyle}
                    // onClick={event => this.sortColumn(event, column, sortOrder)}
                  >
                    {column.text}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {contentShow &&
              contentShow.map((record, rowIndex) => {
                return (
                  <tr
                    key={'record' + rowIndex}
                    onClick={() => {
                      if (onRowClicked) return onRowClicked(record);
                      return null;
                    }}
                  >
                    {columns.map((column, colIndex) => {
                      const _className =
                        typeof column.className === 'function'
                          ? column.className(record)
                          : column.className;

                      if (column.cell && typeof column.cell === 'function') {
                        if (column.key === 'defaultAccount') {
                          return (
                            <td
                              className={_className}
                              key={
                                column.key
                                  ? column.key
                                  : column.text + '_' + colIndex
                              }
                            >
                              {column.cell(defaultAccount)}
                            </td>
                          );
                        }
                        return (
                          <td
                            className={_className}
                            key={
                              column.key
                                ? column.key
                                : column.text + '_' + colIndex
                            }
                          >
                            {column.cell(record, rowIndex)}
                          </td>
                        );
                      } else if (record[column.key]) {
                        return (
                          <td
                            className={_className}
                            key={
                              column.key
                                ? column.key
                                : column.text + '_' + colIndex
                            }
                          >
                            {record[column.key]}
                          </td>
                        );
                      } else {
                        if (column.key === '_index') {
                          return (
                            <td
                              className={_className}
                              key={
                                column.key
                                  ? column.key
                                  : column.text + '_' + colIndex
                              }
                            >
                              {(page - 1) * _pageSize + rowIndex + 1}
                            </td>
                          );
                        }
                        return (
                          <td
                            className={_className}
                            key={
                              column.key
                                ? column.key
                                : column.text + '_' + colIndex
                            }
                          ></td>
                        );
                      }
                    })}
                  </tr>
                );
              })}
          </tbody>
        </table>
        {(!source || !source.length) && (
          <p className="text-center fz-14 mt-2 title-time">
            {t('txt-no-data-found')}
          </p>
        )}
        {source && (
          <div className="d-flex flex-row-reverse align-items-center paging mt-2">
            <div className="d-flex align-items-center">
              <Button
                onClick={() => this._handleNextPage(-1)}
                disabled={page === 1}
                className="d-flex align-items-center justify-content-center"
              >
                {'<'}
              </Button>
              <Button
                onClick={() => this._handleNextPage(1)}
                disabled={!continued}
                className="d-flex align-items-center justify-content-center"
              >
                {'>'}
              </Button>
            </div>
            <span className="fz-14 text-white mr-2">{`${t('txt-label-page')} ${
              page + '/' + _totalPage
            }`}</span>
          </div>
        )}
      </div>
    );
  }
}

export default translate('translations')(PaginationTable);
